import './banner.css';
import { motion } from 'framer-motion';
import { bannerInfo, imageData } from '/src/constants/constants.jsx';
import Logo from '../../../components/logo/logo';
import Video from './Video';

const Banner = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3,
            },
        },
    };

    const childVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    };

    return (
        <div className="banner_main_block">
            {/* Video Background */}
            <Video />

            <div className="svg_grid_overlay">
                <img
                    src={imageData.banner_grid}
                    alt="SVG Grid Overlay"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'fill'
                    }}
                />
            </div>

            {/* Banner Text Overlay */}
            <div className="banner_inner">
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible">
                    <motion.h1 variants={childVariants}>
                        {/*{bannerInfo.title}*/}
                        <Logo
                            isDarkBackground={true}
                            size={2.5}
                            isAnimated={true}
                        />
                    </motion.h1>
                    <motion.h5 variants={childVariants}>
                        {bannerInfo.description}
                    </motion.h5>
                </motion.div>
            </div>
        </div>
    );
};

export default Banner;
